// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-blog-post-js": require("gatsby-module-loader?name=component---src-templates-blog-post-js!/home/alice/abc/new-website-master/src/templates/blog-post.js"),
  "component---src-pages-404-js": require("gatsby-module-loader?name=component---src-pages-404-js!/home/alice/abc/new-website-master/src/pages/404.js"),
  "component---src-pages-index-tsx": require("gatsby-module-loader?name=component---src-pages-index-tsx!/home/alice/abc/new-website-master/src/pages/index.tsx"),
  "component---src-pages-page-2-js": require("gatsby-module-loader?name=component---src-pages-page-2-js!/home/alice/abc/new-website-master/src/pages/page-2.js")
}

exports.json = {
  "layout-index.json": require("gatsby-module-loader?name=path---!/home/alice/abc/new-website-master/.cache/json/layout-index.json"),
  "sweet-panda.json": require("gatsby-module-loader?name=path---sweet-panda!/home/alice/abc/new-website-master/.cache/json/sweet-panda.json"),
  "404.json": require("gatsby-module-loader?name=path---404!/home/alice/abc/new-website-master/.cache/json/404.json"),
  "index.json": require("gatsby-module-loader?name=path---index!/home/alice/abc/new-website-master/.cache/json/index.json"),
  "page-2.json": require("gatsby-module-loader?name=path---page-2!/home/alice/abc/new-website-master/.cache/json/page-2.json"),
  "404-html.json": require("gatsby-module-loader?name=path---404-html!/home/alice/abc/new-website-master/.cache/json/404-html.json")
}

exports.layouts = {
  "layout---index": require("gatsby-module-loader?name=component---src-layouts-index-tsx!/home/alice/abc/new-website-master/.cache/layouts/index.js")
}


// WEBPACK FOOTER //
// ./.cache/async-requires.js